import { render } from "./index.vue?vue&type=template&id=898e0b86&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=898e0b86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c888307087c990cfda5c0d18ef320e2e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-898e0b86"],['__file',"src/components/scCodeEditor/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "898e0b86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('898e0b86', __exports__)) {
    api.reload('898e0b86', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=898e0b86&scoped=true", () => {
    api.rerender('898e0b86', render)
  })

}


export default __exports__